import Vue from 'vue';


// 站内即时消息顶部图标组件
import SHMsgIcon from './icon/index.js'
Vue.use(SHMsgIcon);


// WEBPACK FOOTER //
// ./src/components/base/view/msg/cmps/cmps.js